import request from '../utils/request'
import global from '../config/global'

function get(params = {}) {
  return request({
    url: global.endpoint.USERS_ME_ONBOARDING_PROCESS,
    method: 'get',
    params
  })
}

function update(data = {}) {
  return request({
    url: global.endpoint.USERS_ME_ONBOARDING_PROCESS,
    method: 'put',
    data
  })
}

export default {
  get,
  update,
}
